import React,{useState,useRef,useEffect} from 'react'
import { Formik, Field } from 'formik'
import axios from 'axios'
import moment from 'moment'
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'
import parse from 'html-react-parser'

import { Form, Input, TextArea, Button, Select, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'

import { WindowReload, WindowURL, WindowLocation, RouteURL } from '../../../services/redirect'
import Paginations from '../../../services/paginations'
import EntryList from '../../../services/entries'
import Spinner from '../../../services/spinner'
import AlertMessage from '../../../services/alert'
import AlertConfirmation from '../../../services/confirmation'

import AuthDenied from '../../ErrorPage/denied'
import { DropdownComponent } from '../../../components/options'

import AddComponent from './add'
import EditComponent from './edit'

export default function ManageRoleComponent(props){

  const FormReference = useRef();

  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(true);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
      if(data.reload){
        WindowReload();
      }
    }
  }

  /*------------------------------------------------------
    ALERT MESSAGE NOTIFY
    {intent:'info',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}}
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
      if(data.reload){
        WindowReload();
      }
    }
  }



  /*------------------------------------------------------
    ALERT CONFIRMATION
    {intent:'delete',settings:{id:id,centered:false,onclose:true,icon:'warning',title:'Delete Confirmation!',text:'This process is not ireversible. Once you continue the process, the record will be deleted forever on the database.'}}
  -------------------------------------------------------*/
  const [confirm,setconfirm] = useState(true);
  const [confirmcontent, setconfirmcontent] = useState({});
  function Confirmcallback(data){
    if(data.intent=='close'){
      setconfirm(false);
      if(data.reload){
        WindowReload();
      }
    }
    if(data.intent=='confirm'){
      DeleteRecord(data.id);
    }
  }


  /*----------------------------------------
    LIST DATA TABLE
  -----------------------------------------*/
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }
  function handleSubmitForm(values, props){
    if(buttonclick==1){
      props.resetForm();
      TableList(pagenumber,search);
    }else{
      let value={
        name:values.name,
      }
      TableList(pagenumber,values);
    }
  }
  function ReloadList(){
    let value={
      name:'',
    }
    TableList(pagenumber,value);
  }

  const [search, setsearch]  = useState({
			name:'',
	});
  const [list, setlist] = useState([]);
	const [pagenumber, setpagenumber] = useState(1);
	const [totaldata, settotaldata] = useState(0);
	const [entry, setentry] = useState(0);
	const [entrytype, setentrytype] = useState('');

	const [paginations, setpaginations] = useState({
			paginations:[{
			listnav:[],
			pageinfo:'',
			limit_page:'',
			total_page:'',
			total_records:'',
			current_page:'',
			startPage:'',
			endPage:'',
			ellipseLeft:'',
			ellipseRight:'',
			}]
	});

	  function pagenumberfunction(page){
				setpagenumber(page);
        let values={
          name:FormReference.current.values.name,
        }
				TableList(page,values);
		}
		function listreload(){
				TableList(pagenumber,search);
		}
		function searchProcess(){
			  TableList(pagenumber,search);
		}
		function TableList(page,searchstr){

        setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
        setspinner(true);

				let formData = new FormData();
				formData.append('type','list');
				formData.append('search',JSON.stringify(searchstr));
				formData.append('page',page);
				axios.post('/admin/users-management/users-role/request.php',formData)
				.then(function (response) {
						let obj = response.data;
						setentry(obj.entries.val);
						setentrytype(obj.entries.type);
						setlist(obj.listtable);
						setpaginations(obj.paginations);
						settotaldata(obj.paginations.paginations.total_records);
            setspinner(false);
				})
				.catch(function (error){
          setspinner(false);
				});
	}


  /*------------------------------------------------------
          DELETE FUNCTION
  -------------------------------------------------------*/
  function DeleteConfirmation(data){
    setconfirmcontent({intent:'delete',settings:{id:data,centered:false,onclose:true,icon:'warning',title:'Delete Confirmation!',text:'This process is not ireversible. Once you continue the process, record will be deleted forever on the server.'}});
    setconfirm(true);
  }


  function DeleteRecord(data){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:""}});
    setspinner(true);
    setconfirm(false);

    let formData = new FormData();
    formData.append('type','delete');
    formData.append('id',data.id);
    axios.post('/admin/users-management/users-role/request.php',formData)
    .then(function (response) {
        let obj = response.data;

        setspinner(false);

        if(obj=='success'){
          setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully deleted.'}});
          setnotify(true);
          TableList(pagenumber,search);
          setTimeout(function() {setnotify(false);},2000);
        }else{
          setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Delete Failed',text:'Record not successfully deleted.'}});
          setnotify(true);
          setTimeout(function() {setnotify(false);},2000);
        }

    })
    .catch(function (error){
      setspinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
}



  /*------------------------------------------------------
          ADD / EDIT MODAL
  -------------------------------------------------------*/
  const [addForm, setAddForm] = useState(false);
  const [editForm, setEditForm] = useState(false);
  const [dataForm, setDataForm] = useState({});
  function ClassModalBody(data){
    if(data){
      document.body.classList.add("modal");
    }else{
      document.body.classList.remove("modal");
    }
  }
  function CallbackModal(data){
    if(data.close){
      ClassModalBody(false);
      setAddForm(false);
      setEditForm(false);
    }
    if(data.reload){
      TableList(pagenumber,search);
    }
  }


  function FunctionModal(data){
    ClassModalBody(true);
    if(data.add){
      setDataForm(data.info);
      setAddForm(true);
    }
    if(data.edit){
      setDataForm(data.info);
      setEditForm(true);
    }
  }




  /*------------------------------------------------------
          DROPDOWN OPTIONS
  -------------------------------------------------------*/
  const [systemPages, setSystemPages] = useState([]);
  const HandleOptions = async () => {
    const source = await DropdownComponent();
    setSystemPages(source.systempages);
  }


  /*------------------------------------------------------
         AUTH PERMISSION FOR DEVS PAGES
  -------------------------------------------------------*/
  const [loader,setloader] = useState(true);
  const [pageId, setPageId] = useState('9bqx7pnrmcesh5zfd');
  const [authPages, setAuthPages] = useState({
    view:0,
    adding:0,
    editing:0,
    deleting:0
  });
  function AuthPagesPermission(){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setloader(true);

    let formData = new FormData();
    formData.append('type','authPages');
    formData.append('id',pageId);
    axios.post('/admin/users-management/users-permission/request.php',formData)
    .then(function (response) {
        let obj = response.data;

        setAuthPages({
          view:obj.view,
          adding:obj.adding,
          editing:obj.editing,
          deleting:obj.deleting,
        });

        console.log(obj.adding);

        if(obj.view==1){
          TableList(pagenumber,search);
          HandleOptions();
        }
        setloader(false);
    })
    .catch(function (error){
      setloader(false);
      setspinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
 }


  useEffect(()=>{
      AuthPagesPermission();
  },[]);

  return (
    <React.Fragment>


       {addForm&&<AddComponent data={dataForm} callback={CallbackModal}/>}
       {editForm&&<EditComponent data={dataForm} callback={CallbackModal}/>}
       {confirm&&<AlertConfirmation data={confirmcontent} callback={Confirmcallback}/>}
       {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}


       {loader&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

       {(authPages['view']==0&&!loader)&&<AuthDenied/>}
       {(authPages['view']==1&&!loader)&&<React.Fragment>

       <div className="app-page-title"><h1>Users Role</h1></div>
       <div className="app-body-wrapper">

       {/*---------------------------------------------------------
          SEARCH SECTION
         --------------------------------------------------------*/}
       <Formik
         initialValues={search}
         onSubmit={handleSubmitForm}
         innerRef={FormReference}
          >
         {({ values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue, setFieldTouched }) => {
         return(<React.Fragment>
           <div className="search-wrapper">
              <div className="search-body">
                <Form>
                  <Form.Group widths="equal">
                    <Field name="name">
                        {({ field, form }) => (
                        <Form.Field>
                          <label>Name</label>
                          <Input fluid {...field} onChange={handleChange}/>
                        </Form.Field>
                        )}
                      </Field>
                    </Form.Group>
                 </Form>
              </div>
              <div className="search-footer">
                <Button type="button" icon='sync alternate' size='tiny strong' className="LightGrayButton" content='Reset' onClick={() => buttonSubmit(1)}/>
                <Button type="button" icon='search' size='tiny strong' className="LightGrayButton" content='Search' onClick={() => buttonSubmit(2)}/>
                <button type="button" style={{'display':'none'}} ref={buttonEl} onClick={handleSubmit}></button>
              </div>
           </div>
        </React.Fragment>
        )}}
      </Formik>





       {/*---------------------------------------------------------
          TABLE LIST SECTION
         --------------------------------------------------------*/}
       {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

      {!spinner&&<React.Fragment>
      <div className="tableWrapper">
       <div className="panel-table">
         <div className="panel-table-header">
           <div>{entry>0&&<EntryList entrycallback={entry} entryType={entrytype} lengthCallback={totaldata} callbackreload={listreload}/>}</div>
           <div>
            <Button disabled={authPages['adding']==0} className='GreenButton strong' size='tiny' content='Add Role'  icon='plus' onClick={()=>FunctionModal({
              add:true,
              info:{
                list:systemPages,
              }
            })} />
            <Button className='LightGrayButton' size='tiny strong' content='Refresh'  icon='sync alternate' onClick={()=>buttonSubmit(1)} />
           </div>
         </div>

         <div className="panel-table-body">
         <div className="table-responsive">
           <Table celled striped compact='very'>
             <Table.Header>
               <Table.Row>
                 <Table.HeaderCell>Name</Table.HeaderCell>
                 <Table.HeaderCell>Description</Table.HeaderCell>
                 <Table.HeaderCell></Table.HeaderCell>
               </Table.Row>
             </Table.Header>

             <Table.Body>
                   {list.length==0&&<Table.Row negative><Table.Cell  colSpan='3' textAlign="center">No record found</Table.Cell></Table.Row>}
                   {list.map(function(data, key){
                     return <Table.Row key={key} verticalAlign='top' negative={data.status==2}>
                         <Table.Cell>{data.name}</Table.Cell>
                         <Table.Cell>{data.description}</Table.Cell>
                         <Table.Cell collapsing>
                         <Button disabled={authPages['editing']==0} className='BlueButton' size='tiny strong' content='Edit'  icon='uil-edit icon'
                           onClick={()=>FunctionModal({
                             edit:true,
                             info:{
                               id:data.id,
                               name:data.name,
                               description:data.description,
                               list:data.list,
                               super:data.super
                             }
                           })}/>
                          <Button disabled={data.super==2||data.use_role>0} className='RedButton' size='tiny strong' content='Delete' icon='uil-trash-alt icon' onClick={()=>DeleteConfirmation({id:data.id})} />
                          
                         </Table.Cell>
                     </Table.Row>
                   })}
               </Table.Body>
               {list.length>0&&
                 <Table.Footer fullWidth>
                     <Table.Row>
                     <Table.HeaderCell colSpan='3'>
                         <div className="dash-footer"><Paginations callbackPagination={paginations} callbackPagenumber={pagenumberfunction}/></div>
                     </Table.HeaderCell>
                     </Table.Row>
                 </Table.Footer>
               }
           </Table>
          </div>{/*.table-responsive*/}
         </div>{/*.panel-table-body*/}
        </div>{/*.panel-table*/}
       </div>

        </React.Fragment>}

       </div>{/*.app-body-wrapper*/}

      </React.Fragment>}
    </React.Fragment>
  )
}
